import { Reveal, MaskLines, Label } from "./Reveal";

function BotanicalLinework({ className = "" }) {
  return (
    <svg viewBox="0 0 220 220" fill="none" className={className} aria-hidden="true">
      <path
        d="M110 14 a96 96 0 1 0 66 24"
        stroke="#966E50"
        strokeWidth="1.4"
        strokeLinecap="round"
        opacity="0.45"
      />
      <path
        d="M150 42 q22 -18 42 -12"
        stroke="#966E50"
        strokeWidth="1.3"
        strokeLinecap="round"
        opacity="0.55"
      />
      <path d="M176 20 q10 6 16 16" stroke="#966E50" strokeWidth="1.2" strokeLinecap="round" opacity="0.5" />
      <path d="M186 14 q4 10 2 20" stroke="#966E50" strokeWidth="1.2" strokeLinecap="round" opacity="0.45" />
      <circle cx="168" cy="34" r="4.5" stroke="#B86F52" strokeWidth="1.3" opacity="0.55" />
      <circle cx="180" cy="40" r="4.5" stroke="#966E50" strokeWidth="1.3" opacity="0.5" />
    </svg>
  );
}

export default function Idea() {
  return (
    <section id="story" className="relative py-28 md:py-44 overflow-hidden" data-testid="idea-section">
      <BotanicalLinework className="absolute -right-10 top-16 w-44 md:w-64 opacity-70 pointer-events-none" />

      <div className="max-w-[1200px] mx-auto px-6 md:px-10 relative">
        <Label>01 — The idea</Label>

        <h2 className="mt-10 font-serif font-normal text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-[-0.005em] max-w-3xl">
          <MaskLines
            lines={[
              "Nothing stays the same.",
              <em key="i" className="italic text-brown">That's the point.</em>,
            ]}
          />
        </h2>

        <div className="mt-16 md:mt-24 grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-6 space-y-7 text-base md:text-lg leading-relaxed text-smoke">
            <Reveal>
              <p className="text-ink font-serif text-xl md:text-2xl leading-snug">
                Coffee is never quite the same twice.
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <p>
                A harvest exists for a moment. Weather changes. Landscapes change. Cherries
                ripen, are picked and processed. A coffee moves through many hands before it
                reaches a cup.
              </p>
            </Reveal>
            <Reveal delay={0.14}>
              <p>
                What we taste is the result of all of those things coming together at one
                particular moment.
              </p>
            </Reveal>
          </div>

          <div className="md:col-span-5 md:col-start-8 flex flex-col justify-end">
            <Reveal delay={0.1}>
              <blockquote
                className="border-l-2 border-brown pl-6 md:pl-8 font-serif italic text-xl md:text-2xl leading-snug text-forest"
                data-testid="idea-quote"
              >
                Anichya — impermanence — is our reminder to pay attention to that moment.
              </blockquote>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
